export default "__VITE_ASSET__MtwqgIQu__"